if (!customElements.get('accordion-details-animated')) {
  customElements.define('accordion-details-animated', class AccordionDetailsAnimated extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.accordion__content-wrapper');

      this.animation = null;
      this.isCollapsing = false;
      this.isExpanding = false;

      this.animDuration = 350;
      this.animEasing = 'ease-out';

      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.details.style.overflow = 'hidden';
      if (this.isCollapsing || !this.details.open) {
        this.expand();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    expand() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;

      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: this.animDuration,
        easing: this.animEasing
      });

      this.animation.onfinish = () => this.animationFinished(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    shrink() {
      this.isCollapsing = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: this.animDuration,
        easing: this.animEasing
      });

      this.animation.onfinish = () => this.animationFinished(false);
      this.animation.oncancel = () => this.isCollapsing = false;
    }

    animationFinished(open) {
      this.details.open = open;
      this.animation = null;
      this.isCollapsing = false;
      this.isExpanding = false;
      this.details.style.height = '';
      this.details.style.overflow = '';
    }
  });
}